import React, { Component } from 'react';
import {connect} from 'react-redux'
import { X } from "react-feather"

import {months, products, cart, ux} from '../actions'
import Months from '../components/Months'
import MobileMonths from '../components/MobileMonths'
import ProductGrid from '../components/ProductGrid'
import Welcome from '../components/Welcome'



class Shop extends Component {
  constructor(props) {
    super(props);

    this.props.fetchProducts()
    window.scrollTo(0, 0)
  }

  checkPopup() {
    if (this.props.showWelcome && !this.props.isAuthenticated) {
      document.body.classList.add('hide-overflow')
    } else {
      document.body.classList.remove('hide-overflow')
    }
  }

  componentDidUpdate() {
    this.checkPopup()
  }

  handleChange = (selectedOption) => {
    this.props.changeMonth(selectedOption.value)
  }

  render() {
    return (
      <div className="Shop">
        {
          this.props.showWelcome && !this.props.isAuthenticated
          ?
          <div className="ProductPopup-overlay">
            <X className="Welcome-close"/>
            <Welcome
              toggleWelcome={this.props.toggleWelcome}/>
          </div>
          :
          null
        }
        {
          !this.props.approved && this.props.isAuthenticated
          ?
          <div className="Warning-align">
            <p className="Cart-warning red hover container">
              Det måste ingå minst två vinlådor i ett abonnemang
            </p>
          </div>
          :
          null
        }
        <Months theMonth={this.props.theMonth} months={this.props.months}
          changeMonth={this.props.changeMonth} cart={this.props.cart} />
        <div className='Shop-container'>
          <div className="Shop-month-picker container">
            <MobileMonths
              theMonth={this.props.theMonth}
              months={this.props.months}
              changeMonth={this.props.changeMonth}
              cart={this.props.cart}
              formOptions={this.props.formOptions}
              handleChange={this.handleChange}
              />
          </div>
          <ProductGrid products={this.props.products} cart={this.props.cart}
            theMonth={this.props.theMonth} addToCart={this.props.addToCart}
            reduceQuantity={this.props.reduceQuantity} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    products: state.products,
    cart: state.cart,
    theMonth: state.months.theMonth,
    months: state.months.months,
    formOptions: state.months.formOptions,
    isAuthenticated: state.auth.isAuthenticated,
    isLoading: state.auth.isLoading,
    approved: state.shop.approved,
    showWelcome: state.ux.showWelcome
  }
}

const mapDispatchToProps = dispatch => {
  return {
    changeMonth: (monthId) => {
      return dispatch(months.changeMonth(monthId));
    },
    fetchProducts: () => {
      return dispatch(products.fetchProducts());
    },
    addToCart: (product, month) => {
      return dispatch(cart.addToCart(product, month));
    },
    reduceQuantity: (product_id, month) => {
      return dispatch(cart.reduceQuantity(product_id, month))
    },
    toggleWelcome: () => {
      return dispatch(ux.toggleWelcome())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Shop);



// WEBPACK FOOTER //
// ./src/containers/Shop.jsx